"use client";
import { useAuthenticated } from "@gettactic/hooks";

/**
 * Whether the viewer may list who owns a dedicated resource. Core serves that
 * list only to holders of `resource:add`; anyone else would just get a 403.
 */
export const useCanReadResourceOwners = (): boolean => {
  const {
    userContext: { authenticatedUser }
  } = useAuthenticated();
  return !!authenticatedUser?.user?.organization_user?.permissions?.includes(
    "resource:add"
  );
};
